const unit = {
    METERS: 0,
    MILES: 1,
    YARDS: 2,
    FEET: 3,
    KILOMETERS: 4,
};

export default unit;
